// extracted by mini-css-extract-plugin
module.exports = {"image":"AppImage_image_VR3LO","cropContainer":"AppImage_cropContainer_pxnr2"};